import React, { useLayoutEffect, useState } from "react";
import { CreateUnitPageForm } from "./CreateUnitPage_Form";
import { RideUnitCtxProvider } from "../../contexts";
import getFirebase from "../../firebase";

const FormPage = () => {
  const [columns, setColumns] = useState();
  const [rideItems, setRideItems] = useState([]);

  useLayoutEffect(() => {
    getFirebase();
  }, []);
  return (
    <RideUnitCtxProvider>
      <CreateUnitPageForm
        columns={columns}
        setColumns={setColumns}
        rideItems={rideItems}
        setRideItems={setRideItems}
      />
    </RideUnitCtxProvider>
  );
};

export { FormPage };
